<template>
  <div class="d-lg-flex main-app">
    <BaseHeader version="v2" />
    <main class="flex-grow-1 pt-lg-6">
      <slot />
    </main>
  </div>
</template>

<script>
import BaseHeader from "@/components/Base/Header";

export default {
  name: "MainLayout",

  components: {
    BaseHeader,
  },
};
</script>
